import { useDispatch, useSelector } from "react-redux";
import { useForm } from 'react-hook-form';
import { REPO, REPOALL, USER } from "../../services/actions";
import { useNavigate, useParams } from "react-router-dom";
import React from "react";
import { Button, Container, Box, Grid, Tab, Tabs, Pagination, Card, Typography } from "@mui/material";
import Form from './Form';
import ActionBar from "../extra/ActionBar";
import SearchBar from "../extra/SearchBar";
import { isBase64Image } from "../../libs/Libs";
import XTable from "../extra/XTableAnother";
import MoreInfo from "../extra/MoreInfo";
import { BsCopy } from "react-icons/bs";
import FileUploader from "./FileUpload";

export default function View() {
  let dispatch = useDispatch()
  const [open, setOpen] = React.useState(false)
  const [defV, setDefV] = React.useState({})
  const [view, setView] = React.useState(1);
  const navigate = useNavigate();
  let ref = React.createRef()
  let ref2 = React.createRef()
  let repoallState = useSelector((state) => state?.repoallState)
  let repoState = useSelector((state) => state?.repoState)
  let { id } = useParams()

  let user = useSelector((state) => state?.loginState?.auth)
  const [page, setPage] = React.useState(0); // current page  
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchRepos = (id = 0, page = 0) => {
    const url = page === 0 ? `repo/${id}/` : `repo/?page=${page}`;// pass page number    
    dispatch({ type: `${REPOALL}_GET`, payload: url });
  }

  React.useEffect(() => {
    try {
      fetchRepos(id, 0);
    } catch (err) {
    }
  }, [])

  React.useEffect(() => {
    fetchRepos(page);
  }, [page]);


  // Handle filter search
  const handleSearch = (key, value) => {
    const query = `project/0/?filter_by={"${key}__istartswith":"${value}"}`;
    dispatch({ type: `${REPOALL}_GET`, payload: query });
  };
  const tableHeadings = ["ID", "image", "Project Name", "Company Name", "Country", "Duration", "Camera Count"];
  const tableRows = repoallState?.data?.results?.map((project) => ({
    id: project.id,
    image: project.project_image,
    project_name: project.project_name,
    company_name: project.company_name,
    country: project.country,
    duration: project.duration,
    camera_count: project.camera_count,


  }));

  const handleDelete = (id) => {
    dispatch({ type: `${REPO}_DELETE`, payload: id });
  };

  return (
    <>

      {open ? <FileUploader
        commit={defV}
        back={() => { fetchRepos(id, 0); setOpen(false) }}
      />
        : <Container maxWidth="false" className="py-3">
          <ActionBar
            showGrid={[2, 5]}
            onBtnClick={(type, col) => {
              if (type === "grid") {
                setView(1);
              }
              if (type === "tabular") {
                setView(2);
              }
            }}
            hasPermission={user.permissions.includes('repo.add_repository1')}
            label="Repository"
            setOpen={(s) => {
              setDefV({});
              setOpen(true);

            }}
            btnLabel="ADD REPOSITORY" />
          <SearchBar bylist={["project_name"]} handleSearch={handleSearch} />
          {view === 1 && (
            <>
              <Box sx={{ p: 1, mb: 2, borderRadius: "5px", backgroundColor: "#98e1f1ff", display: "flex", alignItems: "center" }}>
                <Typography >Repositories</Typography>
              </Box>
              <Grid container spacing={1}>
                {repoallState?.data?.results?.map((data) => {
                  return <Grid size={{ xs: 12, sm: 4, md: 4 }} spacing={1}>
                    <Card sx={{ border: "1px solid #ccc", borderRadius: "5px", width: 1 }}>
                      <Box sx={{ p: 2, backgroundColor: "#f5f5f5", fontWeight: 800 }}>Client ID: {data.client_id}</Box>
                      <Box sx={{ p: 1, }} >📁 {data.repo_name} </Box>
                      <Box sx={{ p: 1 }}>📅 Created on {data.created_at?.split("T")[0]} </Box>

                      <Box sx={{ p: 1 }}>
                        <hr />
                      </Box>
                      <Box sx={{ p: 1 }}>
                        <Box onClick={() => navigate(`/repository/documents/${data.id}?back=/repository`)}
                          className={'btn-primary'}
                          sx={{ display: 'flex', justifyContent: 'space-between', p: 1, mb: 1, border: "1px solid #ccc", borderRadius: "5px" }}>
                          <span>Documents</span> <span style={{ padding: 4, paddingLeft: 8, paddingRight: 8, borderRadius: 10, background: "#054720ff" }}>{data?.documents?.length || 0}</span>
                        </Box>
                        <Box onClick={() => { setDefV(data); setOpen(true) }} className={'btn-primary'} sx={{ p: 1, border: "1px solid #ccc", borderRadius: "5px" }}>
                          Upload New Document
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                })}
              </Grid>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Pagination
                  count={Math.ceil(repoallState?.data?.count / pageSize)}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </Box>
            </>
          )}
          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={(row) => {
                // Find the original project data from the full results
                const originalData = repoallState?.data?.results.find(
                  (project) => project.id === row.id
                );

                // Set the form's default values and open the form
                if (originalData) {
                  setDefV(originalData);
                  setOpen(true);
                }
              }}
              onDelete={handleDelete}
            />
          )}
          {view === 4 && <MoreInfo
            data={{
              ...defV,
              active: defV.active ? "Yes" : "No",
              verify: defV.verify ? "Yes" : "No",
            }}

            skip={['country', 'description', 'error_email', 'no_users', 'owner', 'image']}
            group={['', 'project_name', 'created_at',]}
            icons={{ project_image: <BsCopy /> }}
            css={{ project_image: { color: '#1976d2' } }}
            onClose={() => { setView(1) }} />}

        </Container>}

    </>
  )
}